import { useContext, useEffect, useState } from "react";
import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import { ThemeProvider, createTheme } from "@mui/material";
import { prefixer } from "stylis";
import { ErrorBoundary } from "react-error-boundary";
import { LocaleContext } from "./routing/LangRouter";

// Import constants
import ErrorBoundaryFallback from "./constants/ErrorBoundaryFallback";
import BASE_URL from "./constants/baseUrls";

// Import general components
import Header from "./components/common/header/header";
import LoginModal from "./components/common/login-modal/login-modal";

function App() {
    //general variables
    const [_isUpdateAvailable, setIsUpdateAvailable] = useState(false);
    const { locale } = useContext(LocaleContext);
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const accessToken = localStorage.getItem("accessToken");

    // Theme configuration for RTL (Right-to-Left) layout
    const theme = createTheme({
        direction: locale === "en" ? "ltr" : "rtl",
    });

    // Cache configuration for RTL content
    const rtlCache = createCache({
        key: locale === "en" ? "mui" : "muirtl",
        stylisPlugins: [prefixer, rtlPlugin],
    });

    // Cache configuration for LTR (Left-to-Right) content
    const ltrCache = createCache({
        key: "mui",
    });

    // useEffect(() => {
    //     // Listen for the "newContentAvailable" event
    //     const handleNewContentAvailable = () => {
    //         setIsUpdateAvailable(true);
    //         // Automatically trigger the update and reload
    //         if (navigator.serviceWorker.controller) {
    //             navigator.serviceWorker.controller.postMessage({ type: "SKIP_WAITING" });
    //             window.location.reload();
    //         }
    //     };
    //     window.addEventListener("newContentAvailable", handleNewContentAvailable);

    //     return () => {
    //         window.removeEventListener("newContentAvailable", handleNewContentAvailable);
    //     };
    // }, []);

    // Function to handle errors by sending error data to backend
    const errorHandling = async (error, errorInfo) => {
        const data = {
            error: error.message,
            error_info: errorInfo,
            route: location.pathname,
        };
        const response = await axios.post(`${BASE_URL}/log/front/`, data, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        setSearchParams({ errorId: response.data.data.log_id });
    };

    const [isLoginOpen, setIsLoginOpen] = useState(false);
    useEffect(() => {
        if (searchParams.get("action") === "login") setIsLoginOpen(true);
        else setIsLoginOpen(false);
    }, [searchParams]);

    return (
        <ErrorBoundary
            FallbackComponent={ErrorBoundaryFallback}
            onReset={() => {
                searchParams.delete("errorId");
                setSearchParams(searchParams);
            }}
            onError={(error, errorInfo) => {
                errorHandling(error, errorInfo);
            }}
        >
            <CacheProvider value={locale === "en" ? ltrCache : rtlCache}>
                <ThemeProvider theme={theme}>
                    <div className="container">
                        <ToastContainer rtl={locale === "en" ? false : true} theme="colored" />
                        <Header />
                        <Outlet />
                        <LoginModal open={isLoginOpen} setOpen={setIsLoginOpen} />
                    </div>
                </ThemeProvider>
            </CacheProvider>
        </ErrorBoundary>
    );
}

export default App;

// useEffect(() => {
//     // Listen for the "newContentAvailable" event
//     const handleNewContentAvailable = () => {
//         setIsUpdateAvailable(true);
//     };
//     window.addEventListener("newContentAvailable", handleNewContentAvailable);

//     return () => {
//         window.removeEventListener("newContentAvailable", handleNewContentAvailable);
//     };
// }, []);

// const handleUpdate = () => {
//     if (navigator.serviceWorker.controller) {
//         navigator.serviceWorker.controller.postMessage({ type: "SKIP_WAITING" });
//         window.location.reload();
//     }
// };

//{
//isUpdateAvailable && (
//<div className="update-notification">
//   <Alert severity="success">
//      نسخه جدیدی از آتریپا در دسترس است
//     <Button onClick={handleUpdate}>بروزرسانی</Button>
// </Alert>
//</div>;
//  )} //
//}
//{
/* {isUpdateAvailable && (
                            <div style={{ background: "#f8d7da", padding: "10px", marginTop: "20px" }}>
                                <p>
                                    نسخه جدیدی از آتریپا موجود است
                                    <button onClick={handleUpdate} style={{ marginLeft: "10px" }}>
                                        بروزرسانی
                                    </button>
                                </p>
                            </div>
                        )} */
//}
